module.exports = __webpack_public_path__ + "img/logo_labo_de_ledition.d6bde330.png";